import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/Home.vue'
import Login from '../views/Auth/login.vue'
import OtpPage from '../views/Auth/otp.vue'
import ProfilePage from '../views/profile/index.vue'
import CallbackPage from '../views/Auth/callback.vue'
import i18n from '../i18n'
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/features',
    name: 'features',
    // route level code-splitting
    // this generates a separate chunk (features.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "features" */ '../views/Features.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "privacy" */ '../views/privacy.vue'),
    meta: {
      hideLayout: true
    }
  },

  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import(/* webpackChunkName: "privacy-policy" */ '../views/PrivacyPolicy.vue')
  },

  {
    path: '/how-to-work',
    name: 'how-to-work',
    component: () => import(/* webpackChunkName: "how-to-work" */ '../views/HowToWork.vue')
  },
  {
    path: '/contact-us',
    name: 'contact-us',
    component: () => import(/* webpackChunkName: "contact-us" */ '../views/ContactUs.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      hideLayout: true
    }
  },
  {
    path: '/otp',
    name: 'otp',
    component: OtpPage,
    meta: {
      hideLayout: true
    }
  },
  {
    path: '/callback',
    name: 'callback',
    component: CallbackPage,
    meta: {
      hideLayout: true
    }
  },
  {
    path: '/profile/:access',
    name: 'profile',
    component: ProfilePage,
    meta: {
      hideLayout: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const lang = to.query.lang
  const supportedLangs = ['en', 'ar']

  if (lang && supportedLangs.includes(lang)) {
    i18n.global.locale.value = lang
  } else {
    // إذا لم يتم تحديد لغة، استخدم اللغة الافتراضية
    i18n.global.locale.value = 'en'
  }

  next()
})

export default router
